import testIds from '@provider-portal/common/config/testIds.json';
import { transformStringMapValuesToPaths } from '@provider-portal/common/utils/transformStringMapValuesToPaths';
import { DeepReadonly } from 'utility-types';

export type TestIdConfig = typeof testIds;

export const $tid = transformStringMapValuesToPaths<TestIdConfig>(testIds);

declare global {
  const $tid: DeepReadonly<TestIdConfig>;

  interface Window {
    $tid: TestIdConfig;
  }
}
